<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Afiliados</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative">
          <div class="w-full w-md-auto md-flex-1">
            <div class="d-flex justify-content-between align-items-center justify-content-lg-start">
              <button type="button" class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters">
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-md-none">
                <button type="button" class="button-tooltip text-dark font-weight-bold m-0" v-b-tooltip.hover
                  title="Recargar" @click="loadData()">
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0">
            <div class="d-none d-md-flex">
              <button type="button" class="button-tooltip text-dark font-weight-bold" v-b-tooltip.hover title="Recargar"
                @click="loadData()">
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar placeholder="Buscar por número de documento, nombres o razón social o persona de contacto"
                @search="onSearch" @input="search = $event" class="flex-1" />

              <div class="text-right mt-2 mt-md-0">
                <b-button :to="{ name: 'config-affiliate-create' }" variant="none"
                  class="button button-primary ml-md-2">Agregar</b-button>
              </div>
            </div>
          </section>

          <filter-menu :show="showFilters" @hide="showFilters = false" :options="filterOptions"
            :selectedOptionFilter="filters" @setFilters="setFilters"></filter-menu>
        </div>

        <div class="w-100 d-flex flex-wrap align-items-center mt-2" v-if="showFiltersList">
          <span v-for="(val, name) in filterList" v-bind:key="name" class="filter-item">
            {{ getFilterName(name, val) }}
            <button type="button" class="text-white p-0 bg-transparent border-0 ml-2" @click="deleteFilter(name)">
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="table-responsive mb-0 table-min-height">
        <table class="custom-table w-100">
          <thead>
            <tr>
              <th>
                Tipo <br />
                de documento
              </th>
              <th>
                Número <br />
                de documento
              </th>
              <th>
                Nombre o <br /> razón social
              </th>
              <th>
                Dirección
              </th>
              <th>
                Persona de <br> contacto
              </th>
              <th>
                Número <br />
                de celular
              </th>
              <th>
                Comisión por <br> viaje
              </th>
              <th>
                Categoría
              </th>
              <th>
                Tipo de hotel
              </th>
              <th>Estado</th>
              <th class="pr-md-4">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="text-center">{{ getIdentifierType(o.identifier_type).label }}</td>
              <td class="text-center">{{ o.identifier_number }}</td>
              <td>{{ o.name }}</td>
              <td>{{ o.address }}</td>
              <td>{{ o.contact_person }}</td>
              <td class="text-center">{{ o.phone_number || '-' }}</td>
              <td class="text-center">{{ o.commission ? `${o.commission} ${getComissionType(o.commission_type)}` : '-'
                }}</td>
              <td class="text-center">{{ getCategoryType(o.category_id).label || "-" }}</td>
              <td class="text-center">{{ getHotelType(o.hotel_type).label || "-" }}</td>
              <td class="text-center">
                <span :class="`badge ${getStatus(o.status).color}`">{{
                  getStatus(o.status).label
                }}</span>
              </td>
              <td class="text-center d_option pr-md-3">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem @click="
                      $router.push({
                        name: 'config-affiliate-edit',
                        params: { id: o.id },
                      })
                      " text="Editar" />
                    <DropdownItem :text="getStatus(o.status).action" @click="openChangeStatus(o)" />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination :total="total" :page="page" :page-size="pageSize" :pages="pages" :changePage="changePage"
          :changePageSize="changePageSize" v-if="list.length" />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
      </div>
    </div>

    <ConfirmationModal :show="confirmationModal.show" @hide="closeConfirmationModal" :data="confirmationModal"
      @confirm="confirmModal" />
  </div>
</template>

<script>
import { AffiliateService } from "@/core/services";
import { Constants as LocalConstants } from "@/core/utils";

import {
  Alert,
  Constants,
  Util,
  PaginationMixin,
  DropdownTable,
  DropdownItem,
  SearchBar,
  FilterMenu,
  FilterMixin,
  ConfirmationModal,
  ConfirmationModalMixin
} from "wize-admin";

export default {
  components: {
    SearchBar,
    FilterMenu,
    DropdownTable,
    DropdownItem,
    ConfirmationModal
  },
  mixins: [PaginationMixin, FilterMixin, ConfirmationModalMixin],
  data() {
    return {
      webUrl: process.env.VUE_APP_WEB_URL,
      list: [],
      tooltipType: null,
      filterOptions: [
        {
          label: "Tipo de documento",
          key: "identifier_type",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.IdentifierType.DNI,
            LocalConstants.IdentifierType.RUC,
            LocalConstants.IdentifierType.CE,
            LocalConstants.IdentifierType.PASSPORT
          ],
        },
        {
          label: "Categoría",
          key: "category_id",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.AffiliateCategories.HOTEL,
            LocalConstants.AffiliateCategories.RESTAURANT,
            LocalConstants.AffiliateCategories.TRAVEL_AGENCY,
            LocalConstants.AffiliateCategories.COMPANY
          ],
        },
        {
          label: "Tipo de Hotel",
          key: "hotel_type",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.HotelTypes.BOUTIQUE,
            LocalConstants.HotelTypes.STANDARD,
            LocalConstants.HotelTypes.RESORT
          ],
        },
        {
          label: "Tipo de comisión",
          key: "commission_type",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.CommissionOptions.PERCENTAGE,
            LocalConstants.CommissionOptions.FIXED_AMOUNT
          ],
        },
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.AffiliateStatus.ACTIVE,
            LocalConstants.AffiliateStatus.INACTIVE,
          ],
        }
      ],
    };
  },
  methods: {
    getComissionType(key) {
      let int = parseInt(key);
      // let value = Util.searchValue(int, LocalConstants.CommissionOptions)

      let text = ''

      if (int == LocalConstants.CommissionOptions.PERCENTAGE.key) {
        text = '%';
      } else if (int == LocalConstants.CommissionOptions.FIXED_AMOUNT.key) {
        text = 'Monto fijo';
      } else {
        text = '-';
      }

      return text
    },
    openChangeStatus(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title: "Cambiar estado",
        description: "¿Está seguro que desea cambiar el estado?",
        acceptText: "Aceptar",
        action: "update",
      });
    },
    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "update") this.changeStatus();
    },
    async changeStatus() {
      try {
        await this.$store.dispatch("app/loading", true);

        let status = this.selectedOption.status;
        if (status == LocalConstants.AffiliateStatus.ACTIVE.key) {
          status = LocalConstants.AffiliateStatus.INACTIVE.key;
        } else if (status == LocalConstants.AffiliateStatus.INACTIVE.key) {
          status = LocalConstants.AffiliateStatus.ACTIVE.key;
        }

        await AffiliateService.changeStatus(this.selectedOption.id, status);
        await this.loadData();
        Alert.success("Estado actualizado correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getIdentifierType(key) {
      return Util.searchValue(key, LocalConstants.IdentifierType);
    },
    getCommisionType(key) {
      return Util.searchValue(key, LocalConstants.CommissionOptions);
    },
    getCategoryType(key) {
      return Util.searchValue(key, LocalConstants.AffiliateCategories);
    },
    getHotelType(key) {
      return Util.searchValue(key, LocalConstants.HotelTypes);
    },
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        const params = { page: this.page - 1, size: this.pageSize, sort: "id" };
        const data = { search: this.search, ...this.filters };

        const response = await AffiliateService.list(data, params);
        this.list = JSON.parse(JSON.stringify(response.payload?.items));
        this.total = response.payload?.metadata.totalElements;
        this.pages = response.payload?.metadata.totalPages;
      } catch (error) {
        console.error(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getStatus(key) {
      let keyInt = key == true ? 1 : 2;
      return Util.searchValue(keyInt, LocalConstants.AffiliateStatus);
    },
    getLicenseType(key) {
      return Util.searchValue(key, LocalConstants.LicenseTypesPeru);
    },
  },
  async mounted() {
    await this.loadData();
  },
};
</script>

<style lang="stylus" scoped></style>
